import { useEffect, useRef, useState } from 'react';
import { reduced } from '../lib/motion';
import './Boot.css';

const LOG = [
  'init  · runtime',
  'mount · design system',
  'link  · edge network',
  'sync  · project index',
  'ready · control plane',
];

export default function Boot({ onDone }) {
  const [pct, setPct] = useState(0);
  const [line, setLine] = useState(0);
  const [exiting, setExiting] = useState(false);
  const fired = useRef(false);

  useEffect(() => {
    if (reduced()) {
      onDone();
      return undefined;
    }

    document.body.classList.add('boot-lock');

    const start = performance.now();
    const DURATION = 1750;
    let raf;

    const tick = (now) => {
      const t = Math.min(1, (now - start) / DURATION);
      const eased = 1 - Math.pow(1 - t, 3);
      setPct(Math.round(eased * 100));
      setLine(Math.min(LOG.length - 1, Math.floor(eased * LOG.length)));
      if (t < 1) {
        raf = requestAnimationFrame(tick);
      } else if (!fired.current) {
        fired.current = true;
        setExiting(true);
        setTimeout(() => {
          document.body.classList.remove('boot-lock');
          onDone();
        }, 1050);
      }
    };
    raf = requestAnimationFrame(tick);

    return () => {
      cancelAnimationFrame(raf);
      document.body.classList.remove('boot-lock');
    };
  }, [onDone]);

  if (reduced()) return null;

  return (
    <div className={`boot ${exiting ? 'boot--exit' : ''}`} aria-hidden="true">
      {/* Curtain slats — peel upward in sequence */}
      <div className="boot-slats">
        {[0, 1, 2, 3, 4, 5].map((i) => (
          <span key={i} className="boot-slat" style={{ transitionDelay: `${i * 62}ms` }} />
        ))}
      </div>

      <div className="boot-inner">
        <div className="boot-top">
          <span className="boot-mark">
            <img src={`${process.env.PUBLIC_URL}/test1.png`} alt="" aria-hidden="true" />
          </span>
          <span className="boot-meta">POANTA RAREȘ / SYSTEMS</span>
        </div>

        <div className="boot-center">
          <div className="boot-counter">
            <span className="boot-num">{String(pct).padStart(3, '0')}</span>
            <span className="boot-unit">%</span>
          </div>
          <div className="boot-log">
            {LOG.map((l, i) => (
              <span key={l} className={`boot-log-line ${i <= line ? 'on' : ''}`}>
                <i className="boot-log-dot" />
                {l}
              </span>
            ))}
          </div>
        </div>

        <div className="boot-bar">
          <span className="boot-bar-fill" style={{ transform: `scaleX(${pct / 100})` }} />
        </div>
      </div>
    </div>
  );
}
